import { gql } from '@apollo/client'

export const SEND_CUSTOMER_INVOICE_MUTATION = gql`
  mutation sendCustomerInvoice($processingId: ID!, $attributes: CustomerInvoice!) {
    sendCustomerInvoice(processingId: $processingId, attributes: $attributes) {
      id
    }
  }
`
